import React from 'react';
import { ArrowRight } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function Hero() {
  return <section className="relative w-full px-6 py-16 lg:py-24 overflow-hidden bg-linen" data-id="element-84">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-85">
        {/* Badge */}
        <FadeIn data-id="element-86">
          <span className="inline-block text-rose font-bold text-xs tracking-[0.3em] uppercase mb-8" data-id="element-87">
            Guía Anti-Inflamación
          </span>
        </FadeIn>

        {/* Headline */}
        <FadeIn delay={0.1} data-id="element-88">
          <h1 className="text-6xl md:text-7xl lg:text-8xl leading-[0.9] mb-8 font-serif text-charcoal" data-id="element-89">
            No es tu panza. <br data-id="element-90" />
            <span className="text-rose italic font-medium" data-id="element-91">Es tu noche.</span>
          </h1>
        </FadeIn>

        {/* Decorative Lines & Tagline */}
        <FadeIn delay={0.2} className="w-full max-w-lg mx-auto mb-12" data-id="element-92">
          <div className="h-px w-full bg-charcoal/10 mb-6" data-id="element-93"></div>
          <p className="text-xl md:text-2xl text-body font-light leading-relaxed" data-id="element-94">
            La regla 3-2-1 para apagar antojos sin vivir a dieta.
          </p>
          <div className="h-px w-full bg-charcoal/10 mt-6" data-id="element-95"></div>
        </FadeIn>

        {/* CTA */}
        <FadeIn delay={0.3} data-id="element-96">
          <a href="#precio" className="bg-rose hover:bg-rose-light text-white font-medium text-sm tracking-[0.2em] uppercase px-10 py-5 transition-all duration-300 flex items-center gap-3 shadow-xl shadow-rose/10 hover:shadow-rose/20 rounded-none no-underline" data-id="element-97">
            Quiero mi guía
            <ArrowRight className="w-4 h-4" data-id="element-98" />
          </a>

          <p className="text-xs text-muted mt-6 tracking-wide font-light italic" data-id="element-99">
            *Para mujeres que se "portan bien" de día y pierden el control de
            noche.
          </p>
        </FadeIn>

        {/* Image */}
        <FadeIn delay={0.4} className="mt-14 w-full max-w-4xl" data-id="element-100">
          <div className="relative shadow-2xl shadow-charcoal/10 hover:scale-[1.01] transition-transform duration-700 ease-out" data-id="element-101">
            <img src="https://cdn.magicpatterns.com/uploads/51CFFcpAS5qbpiz6GvYbSa/Mockup1.png" alt="Barriga Rebelde Guide on devices" className="w-full h-auto object-cover grayscale-[10%] contrast-[1.05]" data-id="element-102" />
            <div className="absolute inset-0 ring-1 ring-inset ring-charcoal/5 pointer-events-none" data-id="element-103"></div>
          </div>
        </FadeIn>
      </div>

      {/* Bottom Divider */}
      <div className="absolute bottom-0 left-0 w-full h-px bg-charcoal/5" data-id="element-104"></div>
    </section>;
}